<div
  routerLinkActive=""
  #rlaMenu="routerLinkActive"
  class="text-x-small font-bold flex flex-col gap-1 cursor-pointer text-text-000 dark:text-text-700"
  [class.pointer-events-none]="!isSideMenuOpen()"
>
  <div
    class="h-12 px-4 md:px-3 rounded flex items-center gap-x-1 hover:bg-primary-600 dark:hover:bg-primary-400"
    [class.bg-primary-600]="highlightedGroup()"
    [class.dark:hover:bg-primary-400]="highlightedGroup()"
    (click)="onMenuClick(isMenuOpen())"
  >
    <svg-icon [key]="iconKey()" />
    @if (isSideMenuOpen()) {
      <div class="flex-1">{{ label() }}</div>
      <div class="w-6 h-6">
        <svg-icon class="pointer-events-none" [key]="isMenuOpen() ? 'chevron-up-24' : 'chevron-down-24'" />
      </div>
    }
  </div>

  @if (isMenuOpen() && isSideMenuOpen()) {
    <div @openClose class="font-medium flex flex-col gap-1">
      @for (route of routes(); track route.routeSegments.join('/')) {
        @if (route.permissions) {
          <ng-container *appIfPermission="route.permissions">
            <a
              [routerLink]="route.routeSegments"
              routerLinkActive=""
              #rla="routerLinkActive"
              appSideMenuNestedItemLinkIsActive
              [forcedHighlightState]="route.forcedHighlightState"
              class="py-2 pl-11 md:pl-10 pr-4 rounded text-x-small font-medium flex items-center hover:bg-primary-600 dark:hover:bg-primary-400"
              [ngClass]="
                ((route.forcedHighlightState | sideMenuNestedItemForcedHighlight) ?? rla.isActive)
                  ? ['bg-secondary-500', 'dark:text-text-000', 'dark:hover:bg-secondary-700']
                  : null
              "
              (click)="onLabelClick(route.isShortcut, $event)"
            >
              {{ route.label }}
            </a>
          </ng-container>
        } @else {
          <a
            [routerLink]="route.routeSegments"
            routerLinkActive=""
            #rla="routerLinkActive"
            appSideMenuNestedItemLinkIsActive
            [forcedHighlightState]="route.forcedHighlightState"
            class="py-2 pl-11 md:pl-10 pr-4 rounded text-x-small font-medium flex items-center hover:bg-primary-600 dark:hover:bg-primary-400"
            [ngClass]="
              ((route.forcedHighlightState | sideMenuNestedItemForcedHighlight) ?? rla.isActive)
                ? ['bg-secondary-500', 'dark:text-text-000', 'dark:hover:bg-secondary-700']
                : null
            "
            (click)="onLabelClick(route.isShortcut, $event)"
          >
            {{ route.label }}
          </a>
        }
      }
    </div>
  }

  <!--NOTE: don't remove, this is here to highlight item when menu is closed-->
  @for (route of routes(); track route.routeSegments.join('/')) {
    @if (route.permissions) {
      <ng-container *appIfPermission="route.permissions">
        <a
          class="hidden"
          [routerLink]="route.routeSegments"
          routerLinkActive=""
          #rla="routerLinkActive"
          appSideMenuNestedItemLinkIsActive
          [forcedHighlightState]="route.forcedHighlightState"
        ></a>
      </ng-container>
    } @else {
      <a
        class="hidden"
        [routerLink]="route.routeSegments"
        routerLinkActive=""
        #rla="routerLinkActive"
        appSideMenuNestedItemLinkIsActive
        [forcedHighlightState]="route.forcedHighlightState"
      ></a>
    }
  }
</div>
